import * as React from "react";
import { View, StyleSheet } from "react-native";
import EmptyBox from "app/shared/components/empty-box/empty-box";
import { Surface, useTheme } from "react-native-paper";

const NotFound = () => {
  const { colors } = useTheme();
  return (
    <View style={[styles.container, { backgroundColor: colors.primary }]}>
      <Surface style={{ margin: 64, borderRadius: 24, flex: 1, width: "70%" }}>
        <EmptyBox title="Rất tiếc !!!!" subtitle="Không tìm thấy trang" />
      </Surface>
    </View>
  );
};

export default NotFound;

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: "yellow" },
});
